// Asset Gallery Slider - Single Project Page
import fixCenterModeSwipe from "../../../assets/src/js/features/slick-center-swipe";

document.addEventListener("DOMContentLoaded", function () {
	const $gallery = $(".single-project__gallery-slider");
	if (!$gallery.length) return;

	// Slick clones only (slidesToShow + 1) slides per side for the infinite
	// loop; with variableWidth several slides are visible at once, so
	// slidesToShow: 1 left backward drags exposing blank track. Raise it
	// (capped below the real slide count so clones still get built) purely
	// to deepen the clone buffer — variableWidth controls the layout.
	const cloneDepth = Math.max(1, Math.min(5, $gallery.children().length - 1));

	// Initialize Slick with variableWidth — each slide sizes itself naturally
	$gallery.slick({
		centerMode: true,
		variableWidth: true,
		infinite: true,
		speed: 650,
		slidesToShow: cloneDepth,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		focusOnSelect: true,
		swipeToSlide: true,
		// Low commit distance (~2% of track width) so quick flicks always
		// advance instead of snapping back; ease-out settle reads as momentum.
		touchThreshold: 50,
		cssEase: "cubic-bezier(0.16, 1, 0.3, 1)",
	});

	// Correct multi-slide swipe traversal for centerMode + variableWidth
	fixCenterModeSwipe($gallery);

	// Uniform slide height: every asset renders at the same exact height.
	// The shared height is 75vh, lowered if needed so the widest asset
	// never exceeds 100% of the viewport width — images are never cropped.
	const mediaSelector =
		".single-project__gallery-slide-media img, .single-project__gallery-video-wrap--native video";

	function mediaRatio(el) {
		if (el.tagName === "VIDEO") {
			return el.videoWidth && el.videoHeight
				? el.videoWidth / el.videoHeight
				: 0;
		}
		return el.naturalWidth && el.naturalHeight
			? el.naturalWidth / el.naturalHeight
			: 0;
	}

	function sizeGallerySlides() {
		const $media = $gallery.find(mediaSelector);
		// Cap slide width below the viewport so the adjacent slides always
		// stay visible on both sides (a lightbox handles full-size viewing).
		// Desktop shows large neighbor portions; mobile shows smaller peeks.
		const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
		const maxWidth = window.innerWidth * (isDesktop ? 0.45 : 0.8);
		let commonHeight = window.innerHeight * 0.75;

		// The widest asset, fitted to 100% width, sets the row height
		$media.each(function () {
			const ratio = mediaRatio(this);
			if (ratio > 0) {
				commonHeight = Math.min(commonHeight, maxWidth / ratio);
			}
		});

		$media.css("height", Math.floor(commonHeight) + "px");
		$gallery.slick("setPosition");
	}

	// Re-measure as each asset's dimensions become known, and on resize
	$gallery.find("img").each(function () {
		if (this.complete) return;
		$(this).one("load", sizeGallerySlides);
	});
	$gallery.find("video").each(function () {
		if (this.videoWidth) return;
		$(this).one("loadedmetadata", sizeGallerySlides);
	});

	let resizeTimer;
	$(window).on("resize", function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(sizeGallerySlides, 150);
	});

	sizeGallerySlides();

	// Custom arrow bindings
	$(".single-project__gallery-prev").on("click", function () {
		$gallery.slick("slickPrev");
	});
	$(".single-project__gallery-next").on("click", function () {
		$gallery.slick("slickNext");
	});

	// Lightbox triggers — open on a genuine tap (not a swipe-drag).
	// Slick's swipeToSlide means a drag also fires click on the button, so we
	// measure pointer travel between down and up and treat large moves as drags.
	initGalleryLightbox($gallery);

	// Media control: play/pause videos on slide change
	$gallery.on("afterChange", function (event, slick, currentSlide) {
		handleMediaState(slick, currentSlide);
	});

	// Handle initial state — delay ensures Slick and video elements are fully ready
	setTimeout(function () {
		handleMediaState(
			$gallery.slick("getSlick"),
			$gallery.slick("slickCurrentSlide"),
		);
	}, 200);

	/**
	 * Play active slide video, pause all others.
	 * Attempts unmuted playback first; falls back to muted if browser blocks.
	 */
	function handleMediaState(slick, currentSlide) {
		const slides = slick.$slides;

		slides.each(function (index) {
			const $slide = $(this);
			const isActive = index === currentSlide;
			const $mediaWrap = $slide.find("[data-media-type]");
			const mediaType = $mediaWrap.data("media-type");

			if (mediaType === "video") {
				const video = $slide.find("video")[0];
				const iframe = $slide.find("iframe")[0];

				if (video) {
					handleNativeVideo(video, isActive);
				} else if (iframe) {
					handleEmbedVideo(iframe, $slide, isActive);
				}
			}
		});
	}

	function handleNativeVideo(video, isActive) {
		if (isActive) {
			video.muted = false;
			const playPromise = video.play();
			if (playPromise !== undefined) {
				playPromise.catch(function () {
					video.muted = true;
					video.play();
				});
			}
		} else {
			video.pause();
			video.currentTime = 0;
		}
	}

	function handleEmbedVideo(iframe, $slide, isActive) {
		const platform = $slide.find("[data-platform]").data("platform");

		if (isActive) {
			if (platform === "vimeo") {
				iframe.contentWindow.postMessage(
					JSON.stringify({ method: "play" }),
					"*",
				);
				iframe.contentWindow.postMessage(
					JSON.stringify({ method: "setVolume", value: 1 }),
					"*",
				);
			} else if (platform === "youtube") {
				iframe.contentWindow.postMessage(
					JSON.stringify({ event: "command", func: "playVideo" }),
					"*",
				);
				iframe.contentWindow.postMessage(
					JSON.stringify({ event: "command", func: "unMute" }),
					"*",
				);
			}
		} else {
			if (platform === "vimeo") {
				iframe.contentWindow.postMessage(
					JSON.stringify({ method: "pause" }),
					"*",
				);
			} else if (platform === "youtube") {
				iframe.contentWindow.postMessage(
					JSON.stringify({ event: "command", func: "pauseVideo" }),
					"*",
				);
			}
		}
	}

	// =========================================================================
	// Asset Gallery Lightbox
	// Full-screen popup that renders fresh, full-size media (image / native
	// video / YouTube|Vimeo embed) with its caption. Supports keyboard nav and
	// reuses the project's arrow + X icons. Independent of the Slick carousel —
	// it builds its own media so carousel instances are never disturbed.
	// =========================================================================
	function initGalleryLightbox($slider) {
		const lightbox = document.querySelector("[data-lightbox]");
		if (!lightbox) return;

		let items = [];
		try {
			items = JSON.parse(lightbox.getAttribute("data-items") || "[]");
		} catch (e) {
			items = [];
		}
		if (!items.length) return;

		// Relocate to <body> so the overlay escapes the gallery's stacking
		// context (the gallery sets position:relative; z-index:2, which would
		// otherwise trap the lightbox beneath the sticky site header).
		document.body.appendChild(lightbox);

		const stage = lightbox.querySelector("[data-lightbox-stage]");
		const captionEl = lightbox.querySelector("[data-lightbox-caption]");
		const closeBtn = lightbox.querySelector("[data-lightbox-close]");
		const prevBtn = lightbox.querySelector("[data-lightbox-prev]");
		const nextBtn = lightbox.querySelector("[data-lightbox-next]");

		let current = 0;
		let isOpen = false;

		// Remove all stage media via DOM methods (also stops playback). Avoids
		// innerHTML so there's no XSS surface even though our content is trusted.
		function clearStage() {
			while (stage.firstChild) {
				stage.removeChild(stage.firstChild);
			}
		}

		function render(index) {
			const item = items[index];
			if (!item) return;

			clearStage();

			if (item.type === "image") {
				const img = document.createElement("img");
				img.className = "single-project__lightbox-image";
				img.src = item.image || "";
				if (item.srcset) img.srcset = item.srcset;
				img.alt = item.alt || "";
				stage.appendChild(img);
			} else if (item.videoType === "native") {
				const video = document.createElement("video");
				video.className = "single-project__lightbox-video";
				video.controls = true;
				video.autoplay = true;
				video.loop = true;
				video.playsInline = true;
				video.setAttribute("playsinline", "");
				const source = document.createElement("source");
				source.src = item.video || "";
				source.type = "video/mp4";
				video.appendChild(source);
				stage.appendChild(video);
				const playPromise = video.play();
				if (playPromise !== undefined) {
					playPromise.catch(function () {
						/* autoplay blocked — user can press play */
					});
				}
			} else if (item.videoType === "embed" && item.embedId) {
				const iframe = document.createElement("iframe");
				iframe.className = "single-project__lightbox-iframe";
				iframe.setAttribute("frameborder", "0");
				iframe.setAttribute(
					"allow",
					"autoplay; fullscreen; picture-in-picture; encrypted-media",
				);
				iframe.setAttribute("allowfullscreen", "");
				if (item.platform === "vimeo") {
					iframe.src =
						"https://player.vimeo.com/video/" +
						item.embedId +
						"?title=0&byline=0&portrait=0&badge=0&autoplay=1&loop=1";
				} else {
					iframe.src =
						"https://www.youtube.com/embed/" +
						item.embedId +
						"?autoplay=1&loop=1&playlist=" +
						item.embedId +
						"&modestbranding=1&rel=0&playsinline=1";
				}
				const wrap = document.createElement("div");
				wrap.className = "single-project__lightbox-embed";
				wrap.appendChild(iframe);
				stage.appendChild(wrap);
			}

			// Caption (hidden when empty so the layout collapses cleanly).
			captionEl.textContent = item.caption || "";
			captionEl.style.display = item.caption ? "" : "none";

			// Tag the stage so CSS can size image vs video differently.
			stage.setAttribute("data-current-type", item.type || "");
		}

		function open(index) {
			current = index;
			render(current);
			lightbox.hidden = false;
			// Force reflow so the opacity transition runs.
			void lightbox.offsetWidth;
			lightbox.classList.add("is-open");
			document.body.classList.add("single-project--lightbox-open");
			isOpen = true;
			closeBtn.focus();
		}

		function close() {
			lightbox.classList.remove("is-open");
			document.body.classList.remove("single-project--lightbox-open");
			isOpen = false;
			// Wait for the fade-out, then unmount media to stop playback.
			setTimeout(function () {
				if (!isOpen) {
					lightbox.hidden = true;
					clearStage();
				}
			}, 300);
		}

		function go(delta) {
			current = (current + delta + items.length) % items.length;
			render(current);
		}

		// --- Trigger binding: open on tap, ignore drag (slick swipe) ---
		let downX = 0;
		let downY = 0;
		const DRAG_THRESHOLD = 8; // px of travel before we treat it as a drag

		$slider.on(
			"mousedown touchstart",
			".single-project__gallery-trigger",
			function (e) {
				const point = e.touches ? e.touches[0] : e;
				downX = point.clientX;
				downY = point.clientY;
			},
		);

		$slider.on("click", ".single-project__gallery-trigger", function (e) {
			const moved =
				Math.abs(e.clientX - downX) > DRAG_THRESHOLD ||
				Math.abs(e.clientY - downY) > DRAG_THRESHOLD;
			if (moved) return; // it was a swipe, not a tap
			e.preventDefault();
			const index = parseInt(this.getAttribute("data-lightbox-index"), 10);
			if (!isNaN(index)) open(index);
		});

		// --- Controls ---
		closeBtn.addEventListener("click", close);
		prevBtn.addEventListener("click", function () {
			go(-1);
		});
		nextBtn.addEventListener("click", function () {
			go(1);
		});

		// Click on the dark backdrop (outside the media/caption) closes.
		lightbox.addEventListener("click", function (e) {
			if (e.target === lightbox || e.target === stage) close();
		});

		// Keyboard navigation while open.
		document.addEventListener("keydown", function (e) {
			if (!isOpen) return;
			if (e.key === "Escape") close();
			else if (e.key === "ArrowLeft") go(-1);
			else if (e.key === "ArrowRight") go(1);
		});
	}
});
